'use es6';

import { createContext } from 'react';
export const DeletedMessagesContext = /*#__PURE__*/createContext({
  showDeletedMessages: false
});